import ms from 'ms'
import queryString from 'query-string'
import React, {useContext, useState} from 'react'
import {Field, Form} from 'react-final-form'
import {FormattedMessage, useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import AppStore from '../../../assets/icons/AppStore.svg'
import Search from '../../../assets/icons/vanshare/Search.svg'
import GooglePlay from '../../../assets/imgs/new-vanshare/app/google-play.png'
import GooglePlayDimension from '../../../assets/imgs/new-vanshare/app/google-play.png?size'
import {areaMessages} from '../../../config/commonMessages'
import {
  areaInPrefectureList,
  areaList,
  AreaType,
  CURRENT_LOCATION, enPrefectureToArea,
  getPrefecture,
  Locale,
  prefectureList,
  PrefectureType,
  UrlPrefix, WHOLE_LOCATION,
} from '../../../config/constants'

import {dateToQuery, maxCalendarYear, thisYear} from '../../../helpers/dateUtil'
import LocaleText from '../../common/LocaleText'
import {RouterContext} from '../../containers/Context'
import GoldenContainer from '../../containers/GoldenContainer'
import TopSearchDate from '../../fields/custom/TopSearchDate'
import {TopSearchSelect, TopSearchSelectType} from '../../fields/custom/TopSearchSelect'
import AutoFormSave from '../../fields/form/AutoFormSave'
import { useIsSsr, useLocale } from '../../hocs/hooks'
import styles from './CoverPC.scss'
import legacyStyles from './CoverSM.scss'
import { ListMode } from '../stations/MapListNavbar'
import { isSpView } from '../../../helpers/util'
import TopPC0 from '../../../assets/imgs/new-vanshare/TOP_PC_main_10.png'
import TopPC1 from '../../../assets/imgs/new-vanshare/TOP_PC_main_08.jpg'
import TopPC2 from '../../../assets/imgs/new-vanshare/TOP_PC_main_02.jpg'
import TopPC3 from '../../../assets/imgs/new-vanshare/TOP_PC_main_09.jpg'
import TopPC4 from '../../../assets/imgs/new-vanshare/TOP_PC_main_04.jpg'
import TopPC5 from '../../../assets/imgs/new-vanshare/TOP_PC_main_05.jpg'
import ResponsiveImg, { getResponsiveSrcSetsFromWH } from '../../common/ResponsiveImg'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { getGlobalEnv } from '../../../helpers/coreUtil'
import { isNativeWebview } from '../../../helpers/reactNativeWebview'

export interface IHomeForm {
  category?: string
  area?: AreaType
  carArea?: AreaType
  stationArea?: AreaType
  prefecture?: PrefectureType
  checkIn?: Date
  checkOut?: Date
}

const initialShowBorder = { category: true, area: true, checkIn: true }
const initCheckIn = new Date()
const initCheckOut = new Date(Date.now() + ms('1 day'))

export const checkAreaOrPrefecture = (place?: string) => {
  if (!place || place === WHOLE_LOCATION) return WHOLE_LOCATION
  if (place === CURRENT_LOCATION) return CURRENT_LOCATION
  if (areaList.includes(place)) return place
  if (prefectureList.includes(place)) return `${enPrefectureToArea[place as PrefectureType]}/${place}`
}

export const CoverTextNew = ({ isStation = false }: { isStation: boolean }) => {
  const {history} = useContext(RouterContext)!
  const locale = useLocale()
  const intl = useIntl()
  const onSubmit = (values: IHomeForm) => {
    const {category} = values
    if (category === TopSearchSelectType.station) {
      const {stationArea, checkIn, checkOut} = values
      history.push({
        pathname: `/${locale}/stations/${checkAreaOrPrefecture(stationArea)}/`,
        search: queryString.stringify({
          mode: isSpView() ? undefined : ListMode.map,
          checkIn: dateToQuery(checkIn),
          checkOut: dateToQuery(checkOut)
        })
      })
    } else {
      const { carArea, checkIn, checkOut } = values
      history.push({
        pathname: `/${locale}/car-list/${checkAreaOrPrefecture(carArea)}/`,
        search: queryString.stringify({
          mode: isSpView() ? undefined : ListMode.map,
          checkIn: dateToQuery(checkIn),
          checkOut: dateToQuery(checkOut)
        })
      })
    }
  }
  const [showBorder, setShowBorder] = useState(initialShowBorder)
  return <div className={['position-absolute m-auto', legacyStyles.bottom].join(' ')}>
  <div className={['shadow bg-white rounded-pill', styles.searchBox].join(' ')}>
    <Form
      onSubmit={onSubmit}
      initialValues={{
        checkIn: initCheckIn,
        checkOut: initCheckOut,
        category: isStation ? TopSearchSelectType.station : TopSearchSelectType.car
      }}
    >
      {({handleSubmit, values}) => <>
        <AutoFormSave name={isStation ? 'stationHome' : 'home'}/>
        <form onSubmit={handleSubmit} className="h-100" id="coverForm">
          <div className="d-md-flex flex-md-grow-1 flex-grow-0 h-100">
            <Field
              component={TopSearchSelect}
              selectType={TopSearchSelectType.category}
              className={[styles.fieldMargin, styles.category].join(' ')}
              isBorder={showBorder.category}
              name="category"
              label={<FormattedMessage id="post.categories" />}
              options={[
                {text: intl.formatMessage({ id: 'search.van' }),  value: TopSearchSelectType.car},
                {text: intl.formatMessage({ id: 'search.spotAndActivity' }), value: TopSearchSelectType.station}
              ]}
            />

            <Field
              component={TopSearchSelect}
              selectType={values.category ? values.category : TopSearchSelectType.car}
              className={[styles.fieldMargin, styles.place].join(' ')}
              name={(values.category === TopSearchSelectType.station) ? 'stationArea' : 'carArea'}
              isBorder={showBorder.area}
              onHover={(show: boolean) => {
                setShowBorder({ ...initialShowBorder, category: !show })
              }}
              label={values.category === TopSearchSelectType.station
                ? <LocaleText en="Destination place" ja="滞在先" />
                : <LocaleText en="Departure place" ja="出発地" />
              }
              locale={locale}
              options={[
                {text: intl.formatMessage({ id: 'stationsSearch.allCountry' })},
                {text: intl.formatMessage({ id: 'stationsSearch.currentLocation' }), value: CURRENT_LOCATION},
                ...(areaList.flatMap(area => {
                  const prefectures = areaInPrefectureList[area].map(
                    prefecture => ({ text: `　${getPrefecture(locale, prefecture)}`, value: prefecture })
                  )
                  return [{ text: intl.formatMessage({ ...areaMessages[area] }), value: area }, ...prefectures]
                }))
              ]}
            />

            <div className="flex-grow-1 d-flex">
              <Field
                component={TopSearchDate}
                className={styles.fieldMargin}
                label={values.category === TopSearchSelectType.station
                  ? <FormattedMessage id="stationsSearch.checkIn"/>
                  : <FormattedMessage id="carsSearch.departure" defaultMessage="departure day"/>
                }
                name="checkIn"
                isBorder={showBorder.checkIn}
                onHover={(show: boolean) => {
                  setShowBorder({ ...initialShowBorder, area: !show })
                }}
                isDisabled={(clientDate: Date) => clientDate.getTime() < new Date(Date.now()).setHours(0, 0, 0, 0)}
                minYear={thisYear}
                maxYear={maxCalendarYear}
              />
            </div>

            <div className="flex-grow-1 d-flex">
              <Field
                component={TopSearchDate}
                className={styles.fieldMargin}
                label={values.category === TopSearchSelectType.station
                  ? <FormattedMessage id="stationsSearch.checkOut"/>
                  : <FormattedMessage id="carsSearch.return" defaultMessage="Return day"/>
                }
                isBorder={false}
                onHover={(show: boolean) => {
                  setShowBorder({ ...initialShowBorder, checkIn: !show })
                }}
                name="checkOut"
                isDisabled={(clientDate: Date) => clientDate.getTime() < new Date(Date.now()).setHours(0, 0, 0, 0)}
                minYear={thisYear}
                maxYear={maxCalendarYear}
              />
              <div className="mt-2 mr-2">
                <button type="submit" className={['btn font-weight-bold btn-primary', styles.button].join(' ')}>
                  <Search className="fa mb-1 mr-1"/>
                  <FormattedMessage id="stationsSearch.close"/>
                </button>
              </div>
            </div>

          </div>
        </form>
      </>
      }
    </Form>

  </div>
</div>
}
CoverTextNew.displayName = 'CoverTextNew'

export const CoverCaption = ({slideNumber}: {slideNumber: number}) => {
  const locale = useLocale()
  const isMobileApp = !useIsSsr() && isNativeWebview()

  return <div className={['position-absolute w-100', styles.titleArea].join(' ')}>
    { // for seo reasons only 1 h1 should be used.
      ((slideNumber === 1 && locale === Locale.ja) || (slideNumber === 0 && locale === Locale.en)) && <>
      <h1 className={['text-white form-group mb-0 position-absolute', styles.title].join(' ')}>
        <FormattedMessage id="user.camperShareRent" defaultMessage="For camper rental and car-sharing reservations,"/>
        <br/>
        <FormattedMessage id="user.reserveCarstay" defaultMessage="Choose Carstay."/>
      </h1>
      </>}
    {
      slideNumber === 1 && locale === Locale.en && <div className={['text-white form-group mb-0 position-absolute', styles.title].join(' ')}>
        <LocaleText en="Enjoy Golden Week and summer vacation trip" ja="ゴールデンウィークも夏休みも！" />
        <br/>
        <LocaleText en="with long-term discounts!" ja="長期割引で、お得に旅を楽しもう！" />
      </div>
    }
    { // for other sides use div instead
      slideNumber !== 1 && locale === Locale.ja && <>
      <div className={['text-white form-group mb-0 position-absolute', styles.title].join(' ')}>
        {
          slideNumber === 0 && <>
            <LocaleText en="Would you like to create your own custom camping car" ja="SAny.リノベーションで自分だけの" />
            <br/>
            <LocaleText en="with SAny Renovation?" ja="キャンピングカーをつくりませんか" />
          </>
        }
        {
          slideNumber === 2 && <>
            <LocaleText en="Enjoy Golden Week and summer vacation trip" ja="ゴールデンウィークも夏休みも！" />
            <br/>
            <LocaleText en="with long-term discounts!" ja="長期割引で、お得に旅を楽しもう！" />
          </>
        }
        {
          slideNumber === 3 && <>
            <FormattedMessage id="user.withDog" defaultMessage="With my dog."/>
            <br/>
            <FormattedMessage id="user.takeTrip" defaultMessage="Let's take a road trip!"/>
          </>
        }
        {
          slideNumber === 4 && <>
            <LocaleText en="Enjoy an outdoor sauna" ja="好きな場所で、ととのえる。" />
            <br/>
            <LocaleText en="wherever you like!" ja="アウトドアサウナを楽しもう！" />
          </>
        }
        {
          slideNumber === 5 && <>
            <FormattedMessage id="user.shareNotUsing" defaultMessage="I'll share when I'm not using it!"/>
            <br/>
            <FormattedMessage id="user.haveCamper" defaultMessage="Those who have a camper."/>
          </>
        }
      </div>
    </>}
    <div className={['d-flex position-absolute', styles.app].join(' ')}>
      {
        ((slideNumber === 1 && locale === Locale.ja) || (slideNumber === 0 && locale === Locale.en)) && !isMobileApp && <>
          <a href="https://apps.apple.com/jp/app/id1531721547?l=ja"
             target="_blank"
             rel="noopener noreferrer"
             title="アプリ/apple">
            <AppStore className={styles.appleLink}/>
          </a>
          <div className={styles.androidLink}>
            <a href="https://play.google.com/store/apps/details?id=jp.carstay.android&hl=ja"
               target="_blank"
               rel="noopener noreferrer"
               className="my-auto"
               title="アプリ/android">
              <ResponsiveImg
                url={GooglePlay}
                caption="GooglePlay"
                dimension={GooglePlayDimension}
              />
            </a>
          </div>
        </>
      }
      {
        (slideNumber === 0 || slideNumber === 2 || slideNumber === 3 || slideNumber === 4 || slideNumber === 5) && locale === Locale.ja && (
          <Link
            to={`/${locale}${slideNumber === 0
              ? '/mobilab/?isSany=true'
              : slideNumber === 2
                ? '/car-list/?longRental=true'
                : slideNumber === 3
                  ? '/vanlife-pets/'
                  : slideNumber === 4
                    ? '/vanlife-sauna/'
                    : `${UrlPrefix.holder}/`}`}
            className={[
              'btn btn-primary rounded-pill btn-lg font-weight-bold font-size-15',
              styles.captionBtn
            ].join(' ')}
          >
            {slideNumber === 2
              ? <LocaleText en="Long-term discount lineup are here." ja="長期割引対象車種はこちら" />
              : (slideNumber === 0 || slideNumber === 3)
                ? <LocaleText en="Click here for more detail!" ja="詳しくはこちらから" />
                : slideNumber === 4
                  ? <LocaleText en="Click here for VANLIFE SAUNA page." ja="VANLIFE SAUNA特設ページはこちら" />
                  : <FormattedMessage id="navbar.RentVan"/>}
          </Link>
        )
      } 
      {locale === Locale.en && slideNumber === 1 && (
        <Link to={`/${locale}/car-list/?longRental=true`}
          className={[
            'btn btn-primary rounded-pill btn-lg font-weight-bold font-size-15',
            styles.captionBtn
          ].join(' ')}
        >
          <LocaleText en="Long-term discount lineup are here." ja="長期割引対象車種はこちら" />
        </Link>
      )}
    </div>
  </div>
}

const defaultSettings = {
  arrows: false,
  dots: true,
  customPaging: () => <div className={styles.dot} />,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000
}

const CoverPC = ({ isStation = false }: { isStation?: boolean }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const settings = {
    ...defaultSettings,
    beforeChange: (_: number, after: number) => { setCurrentSlide(after) }
  }
  const locale = useLocale()
  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcSetZeo = getResponsiveSrcSetsFromWH(TopPC0, 1440, undefined, { webp: false, cdn }) // Sany
  const srcSet = getResponsiveSrcSetsFromWH(TopPC1, 1440, undefined, { webp: false, cdn })
  const srcSetSecond = getResponsiveSrcSetsFromWH(TopPC2, 1440, undefined, { webp: false, cdn })
  const srcSetThird = getResponsiveSrcSetsFromWH(TopPC3, 1440, undefined, { webp: false, cdn })
  const srcSetFourth = getResponsiveSrcSetsFromWH(TopPC4, 1440, undefined, { webp: false, cdn })
  const srcSetFifth = getResponsiveSrcSetsFromWH(TopPC5, 1440, undefined, { webp: false, cdn })
  return <div className="w-100">
    <div className="w-100 position-relative overflow-hidden">
      <div className="d-flex">
        <Slider {...settings} className={['w-100', styles.slider].join(' ')}>
        {locale === Locale.ja && <GoldenContainer ratio={1840 / 740}>
          <div className={styles.cover}>
            <ResponsiveImg
              url={TopPC0}
              caption="TopPC"
              className={styles.coverImg}
              srcSet={srcSetZeo}
            />
          </div>
        </GoldenContainer>}
        <GoldenContainer ratio={1840 / 740}>
          <div className={styles.cover}>
            <ResponsiveImg
              url={TopPC1}
              caption="TopPC"
              className={styles.coverImg}
              srcSet={srcSet}
            />
          </div>
        </GoldenContainer>
        <GoldenContainer ratio={1840 / 740}>
          <div className={styles.cover}>
            <ResponsiveImg
              url={TopPC2}
              caption="TopPC"
              className={styles.coverImg}
              srcSet={srcSetSecond}
            />
          </div>
        </GoldenContainer>
        {locale === Locale.ja && <GoldenContainer ratio={1840 / 740}>
          <div className={styles.cover}>
            <ResponsiveImg
              url={TopPC3}
              caption="TopPC"
              className={styles.coverImg}
              srcSet={srcSetThird}
            />
          </div>
        </GoldenContainer>}
        {locale === Locale.ja && <GoldenContainer ratio={1840 / 740}>
          <div className={styles.cover}>
            <ResponsiveImg
              url={TopPC4}
              caption="TopPC"
              className={styles.coverImg}
              srcSet={srcSetFourth}
            />
          </div>
        </GoldenContainer>}
        {locale === Locale.ja && <GoldenContainer ratio={1840 / 740}>
          <div className={styles.cover}>
            <ResponsiveImg
              url={TopPC5}
              caption="TopPC"
              className={styles.coverImg}
              srcSet={srcSetFifth}
            />
          </div>
        </GoldenContainer>}
        </Slider>
      </div>
      <div className={[
        'position-absolute w-100 h-100',
        styles.top
      ].join(' ')}>
        <div className="w-100 h-100">
          <div className="position-relative w-100 h-100">
            <CoverTextNew isStation={isStation}/>
            <CoverCaption slideNumber={currentSlide}/>
          </div>
        </div>
      </div>
    </div>
  </div>
}
CoverPC.displayName = 'CoverPC'
export default CoverPC
